import React from "react";
import "./Preloader.css";
const Preloader = () => {
  return (
    <div id="ploader" className="preloader-overlay">
      <div className="loader-content">
        <div className="loader"></div>
      </div>
    </div>
  );
};

export default Preloader;
